// Small reusable atoms for QuoteDetailPage and its tabs.

export function Metric({ icon, label, value, accent, testid }) {
  return (
    <div className={`tech-card p-4 ${accent ? "border-blue-500/50" : ""}`} data-testid={testid}>
      <div className="flex items-center gap-2 text-slate-400 mb-2">{icon}<div className="label-tech">{label}</div></div>
      <div className={`font-mono-data text-2xl ${accent ? "text-blue-400" : "text-slate-100"}`}>{value}</div>
    </div>
  );
}

export function KV({ k, v }) {
  return (
    <div className="flex justify-between">
      <span className="text-slate-500 text-xs">{k}</span>
      <span className="font-mono-data text-slate-200">{v}</span>
    </div>
  );
}

export function Row({ label, value, bold, accent }) {
  return (
    <div className="px-5 py-3 flex justify-between items-center">
      <span className={`text-sm ${bold ? "text-slate-100 font-medium" : "text-slate-400"}`}>{label}</span>
      <span className={`font-mono-data ${accent ? "text-blue-400 text-xl" : bold ? "text-slate-100 text-base" : "text-slate-200 text-sm"}`}>{value}</span>
    </div>
  );
}

export function Tag({ color, children }) {
  const map = {
    blue:    "bg-blue-500/10 text-blue-300 border-blue-500/30",
    amber:   "bg-amber-500/10 text-amber-300 border-amber-500/30",
    emerald: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
  };
  return <span className={`text-[10px] label-tech px-2 py-1 rounded border ${map[color]}`}>{children}</span>;
}

export function DiffBadge({ level }) {
  const map = {
    low:    { txt: "Bassa", cls: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30" },
    medium: { txt: "Media", cls: "bg-amber-500/10 text-amber-300 border-amber-500/30" },
    high:   { txt: "Alta",  cls: "bg-red-500/10 text-red-300 border-red-500/30" },
  };
  const d = map[level] || map.medium;
  return <span className={`text-[10px] label-tech px-2 py-0.5 rounded border ${d.cls}`}>{d.txt}</span>;
}
